'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Group = require('./Group');

var _Group2 = _interopRequireDefault(_Group);

var _InputSelect = require('./InputSelect');

var _InputSelect2 = _interopRequireDefault(_InputSelect);

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.ControlChoices',

  propTypes: {
    name: _react.PropTypes.string.isRequired,
    value: _react.PropTypes.any.isRequired,
    onChange: _react.PropTypes.func.isRequired,
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired
  },

  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var value = _props.value;
    var options = _props.options;
    var onChange = _props.onChange;

    return _react2['default'].createElement(
      _Group2['default'],
      { name: name },
      _react2['default'].createElement(_InputSelect2['default'], { value: value, options: options, onChange: onChange })
    );
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/ControlChoices.js
// module id = 957
// module chunks = 0